"use client";

import { c as _c } from "react/compiler-runtime";
import { useAIChatMessageContext } from "../contexts";
import { formatTime } from "@/lib/format-data";
import { cx } from "@/lib/tailwind-utils";
interface AIChatMessageTimestampProps {
  className?: string;
}
export function AIChatMessageTimestamp(t0) {
  const $ = _c(9);
  const {
    className
  } = t0;
  const {
    message
  } = useAIChatMessageContext();
  let t1;
  if ($[0] !== message.timestamp) {
    t1 = message.timestamp instanceof Date && !Number.isNaN(message.timestamp.getTime()) ? message.timestamp : null;
    $[0] = message.timestamp;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const safeTimestamp = t1;
  if (!safeTimestamp) {
    return null;
  }
  let t2;
  if ($[2] !== className) {
    t2 = cx("text-tiny text-foreground-muted", className);
    $[2] = className;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== safeTimestamp) {
    t3 = formatTime(safeTimestamp);
    $[4] = safeTimestamp;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== t2 || $[7] !== t3) {
    t4 = <span className={t2}>{t3}</span>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  return t4;
}